import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c8bf4052&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=c8bf4052&prod&lang=stylus&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=c8bf4052&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bf4052",
  null
  
)

export default component.exports